import { render, staticRenderFns } from "./editBlog.vue?vue&type=template&id=5771901f&scoped=true&lang=html&"
import script from "./editBlog.vue?vue&type=script&lang=js&"
export * from "./editBlog.vue?vue&type=script&lang=js&"
import style0 from "./editBlog.vue?vue&type=style&index=0&id=5771901f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5771901f",
  null
  
)

export default component.exports